module.exports = __webpack_public_path__ + "static/img/icon_partner_samsung.5f3a1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_samsung.png
// module id = +8Nd
// module chunks = 1